define(["require", "exports", "./Core", "./Plugin"], function (require, exports, Core_1, Plugin_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Plugin = Plugin_1.default;
    exports.default = Core_1.default;
});
